export default "__VITE_ASSET__DQpC3OAw__"